// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3088a672","651":"bc128847","812":"11ed6c37"}[chunkId] + ".chunk.js";
};